import React, { Component } from 'react';

import SelectSkills from './components/SelectSkills/index';
import Tumbler from './../../../../../Filter/Tumbler'

function array_move(arr, old_index, new_index) {
  // console.log('old_index', old_index, 'new_index', new_index)
  while (old_index < 0) {
      old_index += arr.length;
  }
  while (new_index < 0) {
      new_index += arr.length;
  }
  if (new_index >= arr.length) {
      var k = new_index - arr.length;
      while ((k--) + 1) {
          arr.push(undefined);
      }
  }
   arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);  
   
   arr = arr.filter(item => item ? true : false);
  //  console.log('arr', arr)
   return arr
}

var CardQuestion = React.createClass({
  getInitialState: function(){
    return {
      openChange: false
    }
  },
  openChange: function(){
    this.setState({
      openChange: !this.state.openChange
    })
  },
  moveTop(){
    var wasFound = false;
    if(this.props && this.props.questions && this.props.question){
      this.props.questions.forEach((item, index)=>{
        if(item && item.id == this.props.question.id && !wasFound){
          wasFound = true;
          if(index > 0){
            this.props.saveQuestion(array_move(this.props.questions, index, index - 1))
          }else{
            this.props.saveQuestion(array_move(this.props.questions, index, this.props.questions.length))
          }
          
        }
      })
    }
    
  },
  moveDown(){
    var wasFound = false;
    if(this.props && this.props.questions && this.props.question){
      this.props.questions.forEach((item, index)=>{
        if(item && item.id == this.props.question.id && !wasFound){
          wasFound = true;
          if(index < this.props.questions.length - 1){
            // console.log('moveDown', index,  index + 1)
            this.props.saveQuestion(array_move(this.props.questions, index, index + 1 ))
          }else{
            // console.log('moveDown2', index,  index + 1)
            this.props.saveQuestion(array_move(this.props.questions, index, 0))
          }
        }
      })
    }
    
  },
  render: function(){
    if(!this.state.openChange){
      return(
          <div className="User">
            <div>{this.props.question.question}</div>
            <div className="change" style={{right: 0, padding: '0 5px'}} onClick={this.openChange}>Изменить</div>
            <div className="change" style={{right: '85px', padding: '0 5px'}} onClick={this.moveTop}>  ↑  </div>
            <div className="change" style={{right: '109px', padding: '0 5px'}} onClick={this.moveDown}>  ↓  </div>
          </div>
          
      );
    }else{
      return (
        <CreateChangeQuestion openChange={this.openChange} saveQuestion={this.props.saveQuestion} skills={this.props.skills} questions={this.props.questions} change={this.props.question.id} />
      )
    }
    
  }
})

var CreateChangeQuestion = React.createClass({
  getInitialState: function(){
    if(typeof this.props.change != 'undefined'){
      var question;
      this.props.questions.forEach(element => {
        if(element.id == this.props.change){
          question = element;
        }
      });
      var customVariant = false;
      question.answers.forEach(answer => {
        if(answer.customVariant){
          customVariant = true;
        }
      })
      return {
        questions: this.props.questions,
        openCreateQuestions: true,
        question: question.question,
        answers: question.answers,
        change: true,
        customVariant: customVariant
      }
    }else{
      return {
        questions: this.props.questions,
        openCreateQuestions: this.props.questions && this.props.questions.length ? false : true,
        question: '',
        answers: [
          {
            name: '',
            id: 0
          },
          {
            name: '',
            id: 1
          },
          {
            name: '',
            id: 2
          },
          {
            name: '',
            id: 3
          },
        ],
        customVariant: false
      }
    }
  },
  openOrCloseCreateQustion: function(){

    var result = {openCreateQuestions: !this.state.openCreateQuestions, questions: this.state.questions};

    if(result.openCreateQuestions === false && this.state.question && this.state.answers){
      if(this.state.change){
        for(var element of result.questions){
          if(element.id == this.props.change){
            element.question = this.state.question;
            element.answers = this.state.answers;
          }
        }
      }else{
        result.questions.push({
          question: this.state.question,
          answers: this.state.answers,
          id: result.questions.length
        })
      }
      

      result.question = '';
      result.answers = [
        {
          name: '',
          id: 0
        },
        {
          name: '',
          id: 1
        },
        {
          name: '',
          id: 2
        },
        {
          name: '',
          id: 3
        },
      ];
    }

    if(this.state.change){
      this.props.openChange()
    }

    this.props.saveQuestion(result.questions)

    this.setState(result)
  },
  changeQustion: function(e){
    this.setState({question: e.target.value})
  },
  // changeMinBall: function(e){
  //   this.setState({minBall: e.target.value})
  // },
  // changeTypeSkill: function(type){
  //   this.setState({typeSkill: type})
  // },
  changeAnswer: function(name, id){
    var newAnswers = this.state.answers;
    newAnswers[id].name = name;
    this.setState({answers: newAnswers})
  },
  addBalls: function(newBalls, id){
    var newAnswers = this.state.answers;
    newAnswers[id].balls = newBalls;
    this.setState({answers: newAnswers})
  },
  changeCustomVariant: function(){
    var newAnswers = this.state.answers,
        newCustomVariant = !this.state.customVariant;

    if(newCustomVariant){
      newAnswers[3].name = '';
      newAnswers[3].customVariant = true;
    }else{
      newAnswers[3].customVariant = false;
    }
    this.setState({customVariant: newCustomVariant})
  },
  render: function(){
    if(this.state.openCreateQuestions){
      return(
        <div className="User">
        <div className="CreatePanel">
          <h1 className="headline">{this.state.change ? 'Изменение вопроса' : 'Создание вопроса'}</h1>

          <div className="Filter">
            <div className="filter">
              <div style={{fontSize: 16, lineHeight: '42px', height: 42}}>Добавить свой вариант: </div>
              <Tumbler changer={this.changeCustomVariant} open={this.state.customVariant} type="date" />
            </div>
          </div>
          
          <input type="text" placeholder="Вопрос" value={this.state.question} onChange={this.changeQustion} />
          {this.state.answers.map((item, i)=>{
            if(item.customVariant){
              return null;
            }
            return (
              
              <div key={i} style={{position: 'relative'}}>
                <input type="text" placeholder={'Ответ №' + item.id} value={item.name} onChange={(e)=>{
                  this.changeAnswer(e.target.value, i)
                }} />
                {this.props.skills && this.props.skills.length ? (
                  <SelectSkills balls={item.balls} addBalls={this.addBalls} skills={this.props.skills} id={item.id} />
                ) : null}
                
              </div>
            )
          })}
          {/* <input placeholder="Проходной балл" value={this.state.minBall} onChange={this.changeMinBall} />
          <div style={{marginBottom: 10, overflow: 'hidden', borderRadius: 10, border: '1px solid #000'}}>
            <div onClick={()=> this.changeTypeSkill(0)} style={{display: 'inline-block', width: '50%', textAlign: 'center', padding: '10px 0', background: this.state.typeSkill === 0 ? '#60a0f5' : '#fff'}}>Технический</div>
            <div onClick={()=> this.changeTypeSkill(1)} style={{display: 'inline-block', width: '50%', textAlign: 'center', padding: '10px 0', background: this.state.typeSkill === 1 ? '#60a0f5' : '#fff'}}>Психологический</div>
          </div> */}
          <div onClick={this.openOrCloseCreateQustion} className="SelectSpecialtiesOpen">{this.state.change ? 'Измененить вопрос' : 'Создать вопрос'}</div>
        </div>
      </div>
      )
    }else{
      return(
        <div onClick={this.openOrCloseCreateQustion} className="SelectSpecialtiesOpen">{this.state.change ? 'Измененить вопрос' : 'Создать вопрос'}</div>
      )
    }
  }
})


var CreateQuestions = React.createClass({
  getInitialState: function(){
    return {
      open: false,
      questions: this.props.questions || [],
    }
  },
  openOrClose: function(){
    this.props.saveQuestion(this.state.questions);
    this.setState({open: !this.state.open})
  },

  saveQuestion: function(newQuestions){
    this.setState({questions: newQuestions});
  },
  
  render: function(){
    if(this.state.open){
      return(
        <div className="Specialties" style={{width: '80%'}}>
          <div onClick={this.openOrClose} className="SelectSpecialtiesOpen top">Сохранить</div>
          
          <CreateChangeQuestion saveQuestion={this.saveQuestion} skills={this.props.skills} questions={this.state.questions} />
          
          <div className="UserList">
            {this.state.questions.map((question, i) => {
              return (
                <CardQuestion saveQuestion={this.saveQuestion} skills={this.props.skills} key={i} question={question} questions={this.state.questions} />
              )
            })}
          </div>
        </div>
      );
    }else{
      return(
        <div onClick={this.openOrClose} className="SelectSpecialtiesOpen">{this.state.questions.length ? 'Создать/изменить вопросы (' + this.state.questions.length + ')'  : 'Создать вопросы'}</div>
      );
    }
  }
});

export default CreateQuestions;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppAdmin/components/AdminPanel/components/CreatePanelTest/components/CreateQuestion/index.jsx
 **/